import React, { forwardRef } from 'react';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import CheckBoxOutlined from '@material-ui/icons/CheckBoxOutlined';

const TypeChoiceMulti = forwardRef<SVGSVGElement, SvgIconProps>(
  (props, ref) => <CheckBoxOutlined {...props} ref={ref} />
);

TypeChoiceMulti.displayName = 'TypeChoiceMulti';

export default TypeChoiceMulti;
